<template>
  <div class="d-flex flex-column">
    <app-button
      v-if="!viewMode"
      class="d-flex flex-shrink-0"
      btn-type="solid"
      @click="onScanQrClick"
      enter-to-tab
    >
      <img
        src="../../../assets/images/camera-white.svg"
        width="20"
        height="20"
        class="mr-2"
      >
      {{ $t('surveyQuestionScreen.question.qr.button') }}
    </app-button>
    <div class="modal-mask" v-if="showScanner">
      <div class="modal-wrapper">
        <div class="title">
          <div style="width: 24px;"></div>
          <div class="h3 mb-0">
            {{ $t('surveyQuestionScreen.question.qr.button') }}
          </div>
          <div @click="onCloseScanQr" role="button">
            <smtt-icon class="d-flex align-self-center" icon="close" />
          </div>
        </div>
        <div class="modal-body">
          <slot>
            <div class="video-feed">
              <qrcode-stream @init="onCameraInitialization" @decode="onDecode">
                <div v-if="isCameraLoading" class="message-overlay text-center">{{ cameraOverlayMessage }}</div>
                <div v-if="!isCameraLoading" class="scanner-overlay"></div>
              </qrcode-stream>
            </div>
          </slot>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center mt-4" v-if="answerName">
      <div class="scanned-value d-flex flex-grow-1">
        {{ answerName }}
      </div>
      <app-button
        v-if="!viewMode"
        btn-type="ghost"
        layout="icon"
        icon="delete"
        @click="$emit('onAnswered', '')"
      />
    </div>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader';
import AppButton from '@/components/AppButton';

export default {
  name: 'ScanQr',
  components: {
    QrcodeStream,
    AppButton,
  },
  props: {
    answerName: {
      type: String,
      default: '',
    },
    viewMode: {
      type: Boolean,
      default: false,
    }
  },
  data: ()  => {
    return {
      showScanner: false,
      isCameraLoading: true,
      cameraOverlayMessage: '',
    }
  },
  methods: {
    onDecode(result) {
      this.showScanner = false;
      this.$emit('onAnswered', result);
    },
    onScanQrClick() {
      this.showScanner = true;
    },
    onCloseScanQr() {
      this.showScanner = false;
    },
    async onCameraInitialization(init) {
      try {
        await init;
        this.isCameraLoading = false;
      } catch (error) {
        this.cameraOverlayMessage = this.$t('surveyQuestionScreen.question.qr.error.noPermission')
      }
    }
  },
  created() {
    this.cameraOverlayMessage = this.$t('surveyQuestionScreen.question.qr.loading');
  }
}
</script>

<style scoped>
.title {
  z-index: 1;
  position: absolute;
  top: 0;
  color: white;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
}

.scanner-overlay {
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: rgba(255,0,0, 0.5);
  animation: scanner-animation 4s ease-in-out 0s infinite;
}

.message-overlay {
  font-weight: bold;
  color: white;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  font-size: 24px;
  word-break: normal;
}

@keyframes scanner-animation {
  0% {
    top: 0;
  }
  50% {
    top: 100%;
  }
  100% {
    top: 0;
  }
}

.modal-mask {
    position: fixed;
    z-index: 30;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: black;
    transition: opacity 0.3s ease;
}

.video-feed {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-shrink: 0;
}

.modal-body {
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.scanned-value {
  border: 1px solid #d2d2d2;
  background-color: #fafafa;
  font-family: monospace;
  padding: 10px;
  border-radius: 0.2rem;
  overflow-x: auto;
}
</style>